























































import Navbar from '@/components/navbar/Navbar.vue'
import {MixinScreenSize} from '@/components/mixins/MixinScreenSize'
import {Component} from 'vue-property-decorator'
import AppFooter from '@/components/footer/AppFooter.vue'
import {MetaInfo} from 'vue-meta'
import GetGasOpenModalButton from '@/components/getGas/GetGasButton.vue'
import LastPriceUpdated from '@/components/LastPriceUpdated.vue'
import PoweredBy, {PoweredByItem} from '@/components/PoweredBy.vue'
import FilterNetwork from '@/components/filters/FilterNetwork.vue'
import {TokensTableItemsCollection} from '@/model/collection/TokensTableItemsCollection'
import SwapModal from '@/components/SwapModal.vue'
import TokensPriceScrollableTable from '@/components/TokensPriceScrollableTable.vue'
import {$} from '@/facade'

@Component({
  components: {
    TokensPriceScrollableTable,
    SwapModal,
    PoweredBy,
    LastPriceUpdated,
    AppFooter,
    Navbar,
    GetGasOpenModalButton,
    FilterNetwork,
  },
  computed: {
    $() {
      return $
    },
  },
})
export default class TokensPriceView extends MixinScreenSize {
  poweredByList = [
    {
      url: 'https://flamingo.finance/',
      alt: 'flamingo icon',
      filename: 'flamingo-icon.svg',
    } as PoweredByItem,
    {
      url: 'https://www.forthewin.network/#/',
      alt: 'ftwicon',
      filename: 'for-the-win-logo.svg',
    } as PoweredByItem,
    {
      url: 'https://neofura-1.gitbook.io/api-docs/',
      alt: 'magnet icon',
      filename: 'magnet-icon.svg',
    } as PoweredByItem,
    {
      url: 'https://carrot-fi.xyz/',
      alt: 'carrot swap icon',
      filename: 'carrot-swap.svg',
    } as PoweredByItem,
  ]

  collection = new TokensTableItemsCollection()

  currentOrderBy: string | null = null

  tokensListLoading = true

  async created() {
    this.applyCollection()
    try {
      await this.populateResources()
    } finally {
      this.tokensListLoading = false
    }
  }

  applyCollection() {
    this.collection.orderBy = 'marketCap'
    this.collection.minOrder = 0
    this.collection.asc = false
    const total = this.collection.total
    this.collection.perPage = total != null && total > 0 ? total : 500
    this.collection.isDeprecated = false
  }

  async populateResources() {
    const promises: Array<Promise<any>> = [this.collection.expand()]

    await Promise.all(promises)
  }

  metaInfo(): MetaInfo {
    return {
      title: this.$translate('metadata.title.tokens'),
    }
  }
}
